var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M496 176.003V16.0039H16V176.003H496Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M496 336.002V176.003H16V336.002H496Z",
    fill: "#E32D3C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M496 496V336.001H16V496H496Z",
    fill: "#27AE60"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0001 496H175.999V16H16.0001V496Z",
    fill: "#E32D3C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0447 102.503H37.902C36.6272 102.503 35.5938 103.472 35.5938 104.667V115.569C35.5938 116.765 36.6272 117.734 37.902 117.734H61.0447C62.3195 117.734 63.353 116.765 63.353 115.569V104.667C63.353 103.472 62.3195 102.503 61.0447 102.503Z",
    fill: "white",
    stroke: "#DB161B",
    strokeWidth: 0.161412
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M60.4517 103.135H38.4958C37.2863 103.135 36.3059 104.023 36.3059 105.119V115.112C36.3059 116.208 37.2863 117.097 38.4958 117.097H60.4517C61.6612 117.097 62.6416 116.208 62.6416 115.112V105.119C62.6416 104.023 61.6612 103.135 60.4517 103.135Z",
    fill: "white",
    stroke: "#DB161B",
    strokeWidth: 0.150525
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.5511 106.946L49.8814 106.989L49.9417 107.592L51.0299 108.145L51.877 107.456L52.9043 108.009L51.9373 108.612L52.1792 109.444L53.3881 109.401V110.514L52.4212 110.464L51.9373 111.16L53.0256 111.95L52.1792 112.596L51.2719 111.9L49.9417 112.18L50.002 113.199L48.5511 113.292L48.3695 112.316L47.1606 111.806L46.4952 112.503L45.4672 111.993L46.0723 111.203L45.3466 110.694H44.3186L44.2583 109.258L45.2863 109.351L46.0113 108.518L45.165 107.872L46.2533 107.126L47.0393 107.729L48.3695 107.549L48.5511 106.946V106.946Z",
    fill: "white",
    stroke: "#DB161B",
    strokeWidth: 0.0950321
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9538 111.205C49.7606 111.205 50.4147 110.646 50.4147 109.955C50.4147 109.264 49.7606 108.704 48.9538 108.704C48.147 108.704 47.4929 109.264 47.4929 109.955C47.4929 110.646 48.147 111.205 48.9538 111.205Z",
    fill: "white",
    stroke: "#DB161B",
    strokeWidth: 0.102338
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.8644 103.773L37.7295 105.676Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8644 103.773L37.7295 105.676",
    stroke: "#DB161B",
    strokeWidth: 0.18816
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.2878 103.773L39.1528 105.676Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2878 103.773L39.1528 105.676",
    stroke: "#DB161B",
    strokeWidth: 0.18816
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.7114 103.773L40.5764 105.676Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7114 103.773L40.5764 105.676",
    stroke: "#DB161B",
    strokeWidth: 0.18816
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.1349 103.773L42 105.676Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1349 103.773L42 105.676",
    stroke: "#DB161B",
    strokeWidth: 0.18816
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.5585 103.773L43.4236 105.676Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5585 103.773L43.4236 105.676",
    stroke: "#DB161B",
    strokeWidth: 0.18816
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.9821 103.773L44.8472 105.676Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9821 103.773L44.8472 105.676",
    stroke: "#DB161B",
    strokeWidth: 0.18816
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.4062 103.773L46.2705 105.676Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4062 103.773L46.2705 105.676",
    stroke: "#DB161B",
    strokeWidth: 0.18816
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.8297 103.773L47.6941 105.676Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8297 103.773L47.6941 105.676",
    stroke: "#DB161B",
    strokeWidth: 0.18816
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.2533 103.773L49.1177 105.676Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M51.2533 103.773L49.1177 105.676",
    stroke: "#DB161B",
    strokeWidth: 0.18816
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.6769 103.773L50.5413 105.676Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6769 103.773L50.5413 105.676",
    stroke: "#DB161B",
    strokeWidth: 0.18816
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.1003 103.773L51.9646 105.676Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M54.1003 103.773L51.9646 105.676",
    stroke: "#DB161B",
    strokeWidth: 0.18816
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.5238 103.773L53.3882 105.676Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5238 103.773L53.3882 105.676",
    stroke: "#DB161B",
    strokeWidth: 0.18816
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.8297 103.773L47.6941 105.676Z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8297 103.773L47.6941 105.676",
    stroke: "#DB161B",
    strokeWidth: 0.18816
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.9474 103.773L54.8118 105.676Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9474 103.773L54.8118 105.676",
    stroke: "#DB161B",
    strokeWidth: 0.18816
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.371 103.773L56.2354 105.676Z",
    fill: "white"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M58.371 103.773L56.2354 105.676",
    stroke: "#DB161B",
    strokeWidth: 0.18816
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.7946 103.773L57.6589 105.676Z",
    fill: "white"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7946 103.773L57.6589 105.676",
    stroke: "#DB161B",
    strokeWidth: 0.18816
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.2187 103.773L59.0823 105.676Z",
    fill: "white"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2187 103.773L59.0823 105.676",
    stroke: "#DB161B",
    strokeWidth: 0.18816
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.0823 103.773L61.2187 105.676Z",
    fill: "white"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M59.0823 103.773L61.2187 105.676",
    stroke: "#DB161B",
    strokeWidth: 0.18816
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.6589 103.773L59.7946 105.676Z",
    fill: "white"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6589 103.773L59.7946 105.676",
    stroke: "#DB161B",
    strokeWidth: 0.18816
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.2354 103.773L58.371 105.676Z",
    fill: "white"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2354 103.773L58.371 105.676",
    stroke: "#DB161B",
    strokeWidth: 0.18816
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.8118 103.773L56.9474 105.676Z",
    fill: "white"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8118 103.773L56.9474 105.676",
    stroke: "#DB161B",
    strokeWidth: 0.18816
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.3882 103.773L55.5238 105.676Z",
    fill: "white"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3882 103.773L55.5238 105.676",
    stroke: "#DB161B",
    strokeWidth: 0.18816
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.9646 103.773L54.1003 105.676Z",
    fill: "white"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9646 103.773L54.1003 105.676",
    stroke: "#DB161B",
    strokeWidth: 0.18816
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.5413 103.773L52.6769 105.676Z",
    fill: "white"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5413 103.773L52.6769 105.676",
    stroke: "#DB161B",
    strokeWidth: 0.18816
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.1177 103.773L51.2533 105.676Z",
    fill: "white"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M49.1177 103.773L51.2533 105.676",
    stroke: "#DB161B",
    strokeWidth: 0.18816
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.6941 103.773L49.8297 105.676Z",
    fill: "white"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6941 103.773L49.8297 105.676",
    stroke: "#DB161B",
    strokeWidth: 0.18816
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.2705 103.773L48.4062 105.676Z",
    fill: "white"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2705 103.773L48.4062 105.676",
    stroke: "#DB161B",
    strokeWidth: 0.18816
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.8472 103.773L46.9828 105.676Z",
    fill: "white"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8472 103.773L46.9828 105.676",
    stroke: "#DB161B",
    strokeWidth: 0.18816
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.4236 103.773L45.5585 105.676Z",
    fill: "white"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4236 103.773L45.5585 105.676",
    stroke: "#DB161B",
    strokeWidth: 0.18816
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.1177 103.773L51.2533 105.676Z",
    fill: "white"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M49.1177 103.773L51.2533 105.676",
    stroke: "#DB161B",
    strokeWidth: 0.18816
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42 103.773L44.1349 105.676Z",
    fill: "white"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M42 103.773L44.1349 105.676",
    stroke: "#DB161B",
    strokeWidth: 0.18816
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.5764 103.773L42.7114 105.676Z",
    fill: "white"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5764 103.773L42.7114 105.676",
    stroke: "#DB161B",
    strokeWidth: 0.18816
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.1528 103.773L41.2878 105.676Z",
    fill: "white"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1528 103.773L41.2878 105.676",
    stroke: "#DB161B",
    strokeWidth: 0.18816
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.7295 103.773L39.8644 105.676Z",
    fill: "white"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7295 103.773L39.8644 105.676",
    stroke: "#DB161B",
    strokeWidth: 0.18816
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.8644 114.556L37.7295 116.465Z",
    fill: "white"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8644 114.556L37.7295 116.465",
    stroke: "#DB161B",
    strokeWidth: 0.18816
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.2878 114.556L39.1528 116.465Z",
    fill: "white"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2878 114.556L39.1528 116.465",
    stroke: "#DB161B",
    strokeWidth: 0.18816
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.7114 114.556L40.5764 116.465Z",
    fill: "white"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7114 114.556L40.5764 116.465",
    stroke: "#DB161B",
    strokeWidth: 0.18816
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.1349 114.556L42 116.465Z",
    fill: "white"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1349 114.556L42 116.465",
    stroke: "#DB161B",
    strokeWidth: 0.18816
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.5585 114.556L43.4236 116.465Z",
    fill: "white"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5585 114.556L43.4236 116.465",
    stroke: "#DB161B",
    strokeWidth: 0.18816
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.9821 114.556L44.8472 116.465Z",
    fill: "white"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9821 114.556L44.8472 116.465",
    stroke: "#DB161B",
    strokeWidth: 0.18816
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.4062 114.556L46.2705 116.465Z",
    fill: "white"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4062 114.556L46.2705 116.465",
    stroke: "#DB161B",
    strokeWidth: 0.18816
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.8297 114.556L47.6941 116.465Z",
    fill: "white"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8297 114.556L47.6941 116.465",
    stroke: "#DB161B",
    strokeWidth: 0.18816
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.2533 114.556L49.1177 116.465Z",
    fill: "white"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M51.2533 114.556L49.1177 116.465",
    stroke: "#DB161B",
    strokeWidth: 0.18816
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.6769 114.556L50.5413 116.465Z",
    fill: "white"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6769 114.556L50.5413 116.465",
    stroke: "#DB161B",
    strokeWidth: 0.18816
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.1003 114.556L51.9646 116.465Z",
    fill: "white"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M54.1003 114.556L51.9646 116.465",
    stroke: "#DB161B",
    strokeWidth: 0.18816
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.5238 114.556L53.3882 116.465Z",
    fill: "white"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5238 114.556L53.3882 116.465",
    stroke: "#DB161B",
    strokeWidth: 0.18816
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.8297 114.556L47.6941 116.465Z",
    fill: "white"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8297 114.556L47.6941 116.465",
    stroke: "#DB161B",
    strokeWidth: 0.18816
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.9474 114.556L54.8118 116.465Z",
    fill: "white"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9474 114.556L54.8118 116.465",
    stroke: "#DB161B",
    strokeWidth: 0.18816
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.371 114.556L56.2354 116.465Z",
    fill: "white"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M58.371 114.556L56.2354 116.465",
    stroke: "#DB161B",
    strokeWidth: 0.18816
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.7946 114.556L57.6589 116.465Z",
    fill: "white"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7946 114.556L57.6589 116.465",
    stroke: "#DB161B",
    strokeWidth: 0.18816
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.2187 114.556L59.0823 116.465Z",
    fill: "white"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2187 114.556L59.0823 116.465",
    stroke: "#DB161B",
    strokeWidth: 0.18816
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.0823 114.556L61.2187 116.465Z",
    fill: "white"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M59.0823 114.556L61.2187 116.465",
    stroke: "#DB161B",
    strokeWidth: 0.18816
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.6589 114.556L59.7946 116.465Z",
    fill: "white"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6589 114.556L59.7946 116.465",
    stroke: "#DB161B",
    strokeWidth: 0.18816
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.2354 114.556L58.371 116.465Z",
    fill: "white"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2354 114.556L58.371 116.465",
    stroke: "#DB161B",
    strokeWidth: 0.18816
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.8118 114.556L56.9474 116.465Z",
    fill: "white"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8118 114.556L56.9474 116.465",
    stroke: "#DB161B",
    strokeWidth: 0.18816
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.3882 114.556L55.5238 116.465Z",
    fill: "white"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3882 114.556L55.5238 116.465",
    stroke: "#DB161B",
    strokeWidth: 0.18816
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.9646 114.556L54.1003 116.465Z",
    fill: "white"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9646 114.556L54.1003 116.465",
    stroke: "#DB161B",
    strokeWidth: 0.18816
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.5413 114.556L52.6769 116.465Z",
    fill: "white"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5413 114.556L52.6769 116.465",
    stroke: "#DB161B",
    strokeWidth: 0.18816
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.1177 114.556L51.2533 116.465Z",
    fill: "white"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M49.1177 114.556L51.2533 116.465",
    stroke: "#DB161B",
    strokeWidth: 0.18816
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.6941 114.556L49.8297 116.465Z",
    fill: "white"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6941 114.556L49.8297 116.465",
    stroke: "#DB161B",
    strokeWidth: 0.18816
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.2705 114.556L48.4062 116.465Z",
    fill: "white"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2705 114.556L48.4062 116.465",
    stroke: "#DB161B",
    strokeWidth: 0.18816
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.8472 114.556L46.9828 116.465Z",
    fill: "white"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8472 114.556L46.9828 116.465",
    stroke: "#DB161B",
    strokeWidth: 0.18816
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.4236 114.556L45.5585 116.465Z",
    fill: "white"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4236 114.556L45.5585 116.465",
    stroke: "#DB161B",
    strokeWidth: 0.18816
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.1177 114.556L51.2533 116.465Z",
    fill: "white"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M49.1177 114.556L51.2533 116.465",
    stroke: "#DB161B",
    strokeWidth: 0.18816
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42 114.556L44.1349 116.465Z",
    fill: "white"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M42 114.556L44.1349 116.465",
    stroke: "#DB161B",
    strokeWidth: 0.18816
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.5764 114.556L42.7114 116.465Z",
    fill: "white"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5764 114.556L42.7114 116.465",
    stroke: "#DB161B",
    strokeWidth: 0.18816
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.1528 114.556L41.2878 116.465Z",
    fill: "white"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1528 114.556L41.2878 116.465",
    stroke: "#DB161B",
    strokeWidth: 0.18816
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.7295 114.556L39.8644 116.465Z",
    fill: "white"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7295 114.556L39.8644 116.465",
    stroke: "#DB161B",
    strokeWidth: 0.18816
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.1367 134.433C44.5973 168.209 29.8637 172.48 36.7782 175.201C43.6927 177.922 65.9351 160.492 89.0792 137.333C112.223 114.182 126.394 93.5751 119.481 90.8537C112.568 88.1315 115.87 98.5076 79.1367 134.433Z",
    fill: "white",
    stroke: "#DB161B",
    strokeWidth: 0.24137
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.0616 158.978L62.1591 162.151C50.773 172.94 37.9612 177.384 34.4027 175.481C30.8435 173.579 40.8082 169.135 50.0616 158.978V158.978Z",
    fill: "white",
    stroke: "#DB161B",
    strokeWidth: 0.18816
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.0616 160.248L60.0263 162.789C48.9331 173.162 37.9612 176.113 35.1221 174.849C32.2671 173.579 41.0481 170.011 50.0616 160.248V160.248Z",
    fill: "white",
    stroke: "#DB161B",
    strokeWidth: 0.18816
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M87.234 132.955C87.2053 133.12 87.1264 133.845 87.0546 134.132C87.0546 134.534 87.0115 134.836 86.9684 135.152C86.8536 135.425 86.8751 135.676 86.5234 135.776C86.2865 136.107 86.1357 136.193 85.8198 136.329C85.6045 136.494 85.2743 136.659 84.9297 136.796C84.5779 136.932 84.2549 136.946 83.8744 136.875C83.5586 136.681 83.336 136.487 83.0776 136.329C83.013 136.078 82.9627 135.712 82.8981 135.468C82.9914 135.719 83.0632 136.121 83.0776 136.48C83.0417 136.875 82.8981 137.047 82.7258 137.341",
    stroke: "#DB161B",
    strokeWidth: 0.18816
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M83.9606 138.203C83.9319 138.181 83.9031 138.153 83.8744 138.124C84.0826 138.31 83.9965 138.224 83.5155 137.973C83.1781 137.815 82.812 137.729 82.3669 137.657H81.1322C80.6512 137.657 80.3282 137.722 79.9836 137.815C79.7323 138.038 79.359 138.16 79.1006 138.361C78.8278 138.526 78.713 138.72 78.5694 138.985C78.3253 139.201 78.1674 139.531 77.9448 139.696C77.8515 140.055 77.6433 140.041 77.5069 140.321C77.9233 140.349 78.2607 140.399 78.4761 140.629C78.8494 140.801 78.1674 140.464 78.0382 140.321C77.7438 140.242 77.6721 140.163 77.2413 140.163C76.8393 140.048 76.5953 140.256 76.1789 140.321C75.942 140.443 75.8702 140.478 75.5615 140.478",
    stroke: "#DB161B",
    strokeWidth: 0.18816
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M79.1868 142.122C79.0074 142.129 78.1818 142.265 77.8588 142.122C77.4999 142.036 77.2845 141.863 77.062 141.569C76.9543 141.361 77.062 141.95 77.062 142.201C77.0261 142.66 76.8681 142.667 76.6241 142.983C76.3656 143.127 76.0928 143.335 75.8272 143.45C75.6047 143.622 75.3319 143.737 75.0304 143.845C74.7648 143.952 74.4489 144.067 74.2336 144.232C73.9392 144.419 73.9679 144.649 73.7957 144.936C73.8244 145.324 73.8962 145.539 74.1474 145.726C74.2479 145.984 74.4848 146.25 74.6786 146.429C74.894 146.788 75.1381 146.953 74.5853 147.054C74.2838 147.169 74.1187 147.075 73.7957 147.054",
    stroke: "#DB161B",
    strokeWidth: 0.18816
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M73.6161 147.6C73.4007 147.556 72.6255 147.327 72.2881 147.212H71.0533C70.5724 147.241 70.479 147.37 70.077 147.521C69.8186 147.757 69.6391 147.923 69.2802 148.073C69.0935 148.289 68.7203 148.655 68.5767 148.935C68.469 149.2 68.3972 149.559 68.3972 149.954C68.4044 150.406 68.5408 150.485 68.5767 150.895C68.6772 151.225 68.8351 151.533 69.1079 151.828C69.1438 151.928 69.1725 151.957 69.2802 151.986",
    stroke: "#DB161B",
    strokeWidth: 0.18816
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M69.4023 153.012C69.3664 153.012 69.2803 153.213 69.1511 153.385C68.8711 153.672 68.8352 153.694 68.3973 153.694C68.0097 153.68 68.0456 153.543 67.7728 153.443C67.6435 153.249 67.4784 153.091 67.3349 152.825C67.2344 152.667 67.141 152.416 67.019 152.273C66.9041 152.086 66.7606 151.95 66.6385 151.777C66.5237 151.727 66.4806 151.677 66.3298 151.655C66.6888 151.713 66.7175 151.835 66.9544 152.021C67.0621 152.201 67.1769 152.38 67.2703 152.581C67.3062 152.847 67.3923 153.055 67.3923 153.385C67.3923 153.723 67.3923 153.967 67.2703 154.247C67.1195 154.405 67.0118 154.563 66.8324 154.685C66.6816 154.821 66.5021 155.008 66.3873 155.173C66.1935 155.295 66.0499 155.395 65.8273 155.546C65.6335 155.654 65.4325 155.769 65.1382 155.797C64.7649 155.769 64.6572 155.668 64.3844 155.546C64.1475 155.374 63.9609 155.266 63.7527 155.115C63.5876 155.001 63.4225 154.778 63.3148 154.62C62.9774 154.534 62.762 154.57 62.561 154.742C62.3888 154.857 62.238 155.008 62.1231 155.173C62.0155 155.223 61.8504 155.374 61.7427 155.424",
    stroke: "#DB161B",
    strokeWidth: 0.188161
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M62.4894 155.567C62.5899 155.61 62.9488 155.862 63.1139 155.955C63.2144 156.278 63.3724 156.458 63.4226 156.802C63.5088 157.14 63.5016 157.506 63.5016 157.886C63.4154 158.281 63.2503 158.568 63.1139 158.884C62.8627 159.056 62.7406 159.171 62.4104 159.351C62.1017 159.394 61.7931 159.43 61.3982 159.43C61.1542 159.508 60.6947 159.544 60.4578 159.43C60.1132 159.379 59.8527 159.243 59.6007 159.121C59.3121 158.956 59.1348 158.805 58.8196 158.654C58.6667 158.432 58.4291 158.231 58.1958 157.958C58.0013 157.699 57.8584 157.556 57.7271 157.269C57.8426 157.599 58.0178 157.886 58.1176 158.195C58.2949 158.518 58.3983 158.64 58.4298 159.042C58.5382 159.365 58.5081 159.753 58.5081 160.119C58.4736 160.37 58.4557 160.844 58.3516 161.045V161.282",
    stroke: "#DB161B",
    strokeWidth: 0.18816
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9473 162.51V162.625C50.9473 162.323 50.9394 162.474 51.0729 163.07C51.3098 163.335 51.8654 163.407 52.3285 163.292C52.7348 162.998 52.7218 162.768 53.4584 162.625C54.1698 162.668 54.4411 162.854 54.8396 163.07C55.3119 163.278 55.5301 163.386 55.8439 163.852C55.9996 164.233 56.0865 164.491 55.5926 164.635C55.1999 164.886 54.7333 165.022 54.2114 165.087C53.6314 165.087 53.2136 165.022 52.9559 165.309C52.5575 165.676 52.5797 165.898 52.5797 166.537C52.4455 166.738 52.4189 167.327 52.3285 167.549C51.9796 167.693 51.775 167.772 51.1985 167.772C51.0629 167.427 50.9128 166.803 50.8217 166.429C50.7233 166.027 50.6932 165.467 50.4448 165.195C50.2107 164.893 49.9114 164.62 49.5661 164.412C49.4125 164.218 49.1196 164.06 48.8131 163.967C49.3055 164.19 49.3759 164.434 49.4405 164.972C49.0076 165.166 48.892 165.302 48.1849 165.309C47.49 165.259 47.322 165.101 47.055 164.75C47.0069 165.309 46.8052 165.496 46.6788 165.984C46.4204 166.322 46.3106 166.666 46.0507 167.097C46.1613 167.643 46.3996 167.664 46.4276 168.332C46.5905 168.77 46.5726 169.186 46.9294 169.452C47.0887 169.624 47.2079 169.66 47.5575 169.674C46.8303 169.674 46.4068 169.602 45.9251 169.337C45.5525 169.136 45.2711 168.877 44.9208 168.669C44.4764 168.382 43.9273 168.116 43.414 167.994C42.8339 167.994 42.4161 167.937 42.1584 168.217C41.8031 168.447 41.564 168.834 41.4054 169.337C41.2891 169.918 41.2446 170.306 41.531 170.679C41.7435 171.117 41.7916 171.282 41.531 171.799C41.2388 172.165 40.8045 172.208 40.1498 172.359C39.6717 172.337 39.2123 172.244 38.8943 172.136",
    stroke: "#DB161B",
    strokeWidth: 0.18816
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.547 103.953C133.874 77.4939 144.046 54.9787 141.246 53.6923C138.454 52.4066 123.752 72.8342 108.426 99.2898L118.547 103.953Z",
    fill: "white",
    stroke: "#DB161B",
    strokeWidth: 0.190967
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.535 103.486C132.316 77.9608 142.503 56.4126 140.27 55.3839C138.038 54.3552 124.226 74.2337 109.438 99.7553",
    fill: "white"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M117.535 103.486C132.316 77.9608 142.503 56.4126 140.27 55.3839C138.038 54.3552 124.226 74.2337 109.438 99.7553",
    stroke: "#DB161B",
    strokeWidth: 0.167766
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M114.994 90.1709C113.192 93.1551 111.29 96.5657 109.438 99.7559L117.535 103.487C119.38 100.294 121.397 96.9325 123.084 93.8988L114.994 90.1709V90.1709Z",
    fill: "white",
    stroke: "#DB161B",
    strokeWidth: 0.190405
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115.676 91.2002C113.881 94.1844 112.625 96.4679 110.78 99.6581L116.846 102.453C118.698 99.264 120.062 97.03 121.749 93.9963L115.676 91.2002Z",
    fill: "white",
    stroke: "#DB161B",
    strokeWidth: 0.190405
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M116.033 92.7924L120.08 94.6562L116.487 100.859L112.44 98.9948L116.033 92.7924Z",
    fill: "white",
    stroke: "#DB161B",
    strokeWidth: 0.19082
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.084 94.6582L112.446 98.9963Z",
    fill: "white"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M120.084 94.6582L112.446 98.9963",
    stroke: "#DB161B",
    strokeWidth: 0.190405
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.487 100.859L116.035 92.7939Z",
    fill: "white"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M116.487 100.859L116.035 92.7939",
    stroke: "#DB161B",
    strokeWidth: 0.190405
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M138.375 63.0831L134.326 61.2188Z",
    fill: "white"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M138.375 63.0831L134.326 61.2188",
    stroke: "#DB161B",
    strokeWidth: 0.190405
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M138.379 60.1608C137.749 60.3198 137.122 60.0002 136.979 59.4469C136.837 58.8936 137.233 58.3161 137.864 58.1571C138.495 57.9981 139.121 58.3177 139.264 58.871C139.406 59.4243 139.01 60.0018 138.379 60.1608Z",
    fill: "#DB161B",
    stroke: "#DB161B",
    strokeWidth: 0.247227
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.418 89.8096C85.418 112.022 85.5472 120.392 83.9104 121.541C82.3598 122.768 39.1528 121.541 39.1528 127.887C39.1528 134.233 74.7433 140.579 85.418 140.579C99.6533 140.579 106.775 134.233 106.775 121.541V89.8096H85.418Z",
    fill: "white",
    stroke: "#DB161B",
    strokeWidth: 0.173816
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.418 96.1553V99.3283C92.5392 100.386 99.6533 100.386 106.775 99.3283V96.1553C99.6533 97.2134 92.5392 97.2134 85.418 96.1553Z",
    fill: "white",
    stroke: "#DB161B",
    strokeWidth: 0.150527
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.418 89.8096V92.9825C92.5392 94.04 99.6533 94.04 106.775 92.9825V89.8096C99.6533 90.867 92.5392 90.867 85.418 89.8096Z",
    fill: "white",
    stroke: "#DB161B",
    strokeWidth: 0.150527
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.418 92.9824V96.1554C92.5392 97.2135 99.6533 97.2135 106.775 96.1554V92.9824C99.6533 94.0398 92.5392 94.0398 85.418 92.9824Z",
    fill: "white",
    stroke: "#DB161B",
    strokeWidth: 0.150527
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.418 99.3281V102.503C92.5392 103.558 99.6533 103.558 106.775 102.503V99.3281C99.6533 100.386 92.5392 100.386 85.418 99.3281Z",
    fill: "white",
    stroke: "#DB161B",
    strokeWidth: 0.150527
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M86.3888 95.4707C86.9249 95.4707 87.3594 95.1642 87.3594 94.7861C87.3594 94.4081 86.9249 94.1016 86.3888 94.1016C85.8528 94.1016 85.4182 94.4081 85.4182 94.7861C85.4182 95.1642 85.8528 95.4707 86.3888 95.4707Z",
    fill: "white",
    stroke: "#DB161B",
    strokeWidth: 0.188159
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M90.2709 95.8135C90.807 95.8135 91.2415 95.507 91.2415 95.1289C91.2415 94.7508 90.807 94.4443 90.2709 94.4443C89.7348 94.4443 89.3003 94.7508 89.3003 95.1289C89.3003 95.507 89.7348 95.8135 90.2709 95.8135Z",
    fill: "white",
    stroke: "#DB161B",
    strokeWidth: 0.188159
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M94.1542 96.1553C94.6903 96.1553 95.1248 95.8488 95.1248 95.4707C95.1248 95.0926 94.6903 94.7861 94.1542 94.7861C93.6182 94.7861 93.1836 95.0926 93.1836 95.4707C93.1836 95.8488 93.6182 96.1553 94.1542 96.1553Z",
    fill: "white",
    stroke: "#DB161B",
    strokeWidth: 0.188162
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M98.0363 96.1553C98.5723 96.1553 99.0069 95.8488 99.0069 95.4707C99.0069 95.0926 98.5723 94.7861 98.0363 94.7861C97.5002 94.7861 97.0657 95.0926 97.0657 95.4707C97.0657 95.8488 97.5002 96.1553 98.0363 96.1553Z",
    fill: "white",
    stroke: "#DB161B",
    strokeWidth: 0.188162
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M101.918 95.8135C102.454 95.8135 102.889 95.507 102.889 95.1289C102.889 94.7508 102.454 94.4443 101.918 94.4443C101.382 94.4443 100.948 94.7508 100.948 95.1289C100.948 95.507 101.382 95.8135 101.918 95.8135Z",
    fill: "white",
    stroke: "#DB161B",
    strokeWidth: 0.188159
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M105.801 95.4707C106.337 95.4707 106.772 95.1642 106.772 94.7861C106.772 94.4081 106.337 94.1016 105.801 94.1016C105.265 94.1016 104.831 94.4081 104.831 94.7861C104.831 95.1642 105.265 95.4707 105.801 95.4707Z",
    fill: "white",
    stroke: "#DB161B",
    strokeWidth: 0.188159
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.418 105.676L106.775 122.811Z",
    fill: "white"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M85.418 105.676L106.775 122.811",
    stroke: "#DB161B",
    strokeWidth: 0.18816
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.55 105.676L106.775 120.902Z",
    fill: "white"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M87.55 105.676L106.775 120.902",
    stroke: "#DB161B",
    strokeWidth: 0.18816
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.3999 106.308L106.774 119Z",
    fill: "white"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M90.3999 106.308L106.774 119",
    stroke: "#DB161B",
    strokeWidth: 0.18816
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.5393 106.308L106.775 117.097Z",
    fill: "white"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M92.5393 106.308L106.775 117.097",
    stroke: "#DB161B",
    strokeWidth: 0.18816
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.6714 106.308L106.775 115.195Z",
    fill: "white"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M94.6714 106.308L106.775 115.195",
    stroke: "#DB161B",
    strokeWidth: 0.18816
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.8032 106.308L106.774 113.292Z",
    fill: "white"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M96.8032 106.308L106.774 113.292",
    stroke: "#DB161B",
    strokeWidth: 0.18816
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.9426 106.308L106.775 111.383Z",
    fill: "white"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M98.9426 106.308L106.775 111.383",
    stroke: "#DB161B",
    strokeWidth: 0.18816
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.075 106.308L106.775 110.119Z",
    fill: "white"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M101.075 106.308L106.775 110.119",
    stroke: "#DB161B",
    strokeWidth: 0.18816
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.214 106.308L106.774 108.849Z",
    fill: "white"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M103.214 106.308L106.774 108.849",
    stroke: "#DB161B",
    strokeWidth: 0.18816
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.346 106.308L106.774 107.578Z",
    fill: "white"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M105.346 106.308L106.774 107.578",
    stroke: "#DB161B",
    strokeWidth: 0.18816
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.418 107.578L106.775 124.714Z",
    fill: "white"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M85.418 107.578L106.775 124.714",
    stroke: "#DB161B",
    strokeWidth: 0.18816
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.775 105.676L83.2859 124.714Z",
    fill: "white"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M106.775 105.676L83.2859 124.714",
    stroke: "#DB161B",
    strokeWidth: 0.18816
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.635 105.676L83.9966 122.172Z",
    fill: "white"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M104.635 105.676L83.9966 122.172",
    stroke: "#DB161B",
    strokeWidth: 0.18816
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.793 106.308L85.418 119Z",
    fill: "white"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M101.793 106.308L85.418 119",
    stroke: "#DB161B",
    strokeWidth: 0.18816
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.6533 106.308L85.418 117.097Z",
    fill: "white"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M99.6533 106.308L85.418 117.097",
    stroke: "#DB161B",
    strokeWidth: 0.18816
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.5212 106.308L85.418 115.195Z",
    fill: "white"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M97.5212 106.308L85.418 115.195",
    stroke: "#DB161B",
    strokeWidth: 0.18816
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.382 106.308L85.418 113.292Z",
    fill: "white"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M95.382 106.308L85.418 113.292",
    stroke: "#DB161B",
    strokeWidth: 0.18816
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.2499 106.308L85.418 111.383Z",
    fill: "white"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M93.2499 106.308L85.418 111.383",
    stroke: "#DB161B",
    strokeWidth: 0.18816
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.1107 106.308L85.418 110.119Z",
    fill: "white"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1107 106.308L85.418 110.119",
    stroke: "#DB161B",
    strokeWidth: 0.18816
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.9786 106.308L85.418 108.849Z",
    fill: "white"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M88.9786 106.308L85.418 108.849",
    stroke: "#DB161B",
    strokeWidth: 0.18816
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.8394 106.308L85.418 107.578Z",
    fill: "white"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M86.8394 106.308L85.418 107.578",
    stroke: "#DB161B",
    strokeWidth: 0.18816
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.775 107.578L83.2859 126.616Z",
    fill: "white"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M106.775 107.578L83.2859 126.616",
    stroke: "#DB161B",
    strokeWidth: 0.18816
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.775 109.48L83.2859 128.518Z",
    fill: "white"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M106.775 109.48L83.2859 128.518",
    stroke: "#DB161B",
    strokeWidth: 0.18816
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.775 111.383L83.2859 130.428Z",
    fill: "white"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M106.775 111.383L83.2859 130.428",
    stroke: "#DB161B",
    strokeWidth: 0.18816
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.775 113.292L83.2859 132.33Z",
    fill: "white"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M106.775 113.292L83.2859 132.33",
    stroke: "#DB161B",
    strokeWidth: 0.18816
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.775 115.194L83.2859 134.232Z",
    fill: "white"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M106.775 115.194L83.2859 134.232",
    stroke: "#DB161B",
    strokeWidth: 0.18816
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.775 117.097L83.2859 136.135Z",
    fill: "white"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M106.775 117.097L83.2859 136.135",
    stroke: "#DB161B",
    strokeWidth: 0.18816
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.775 118.999L83.2859 138.037Z",
    fill: "white"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M106.775 118.999L83.2859 138.037",
    stroke: "#DB161B",
    strokeWidth: 0.18816
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.775 120.909L83.2859 139.947Z",
    fill: "white"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M106.775 120.909L83.2859 139.947",
    stroke: "#DB161B",
    strokeWidth: 0.18816
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.775 122.812L84.7073 140.579Z",
    fill: "white"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M106.775 122.812L84.7073 140.579",
    stroke: "#DB161B",
    strokeWidth: 0.18816
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.775 124.714L86.8394 140.579Z",
    fill: "white"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M106.775 124.714L86.8394 140.579",
    stroke: "#DB161B",
    strokeWidth: 0.18816
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.057 127.255L90.3999 139.947Z",
    fill: "white"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M106.057 127.255L90.3999 139.947",
    stroke: "#DB161B",
    strokeWidth: 0.18816
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.346 129.789L92.5393 139.947Z",
    fill: "white"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M105.346 129.789L92.5393 139.947",
    stroke: "#DB161B",
    strokeWidth: 0.18816
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.925 132.962L97.5212 138.037Z",
    fill: "white"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M103.925 132.962L97.5212 138.037",
    stroke: "#DB161B",
    strokeWidth: 0.18816
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.418 109.48L106.057 125.984Z",
    fill: "white"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M85.418 109.48L106.057 125.984",
    stroke: "#DB161B",
    strokeWidth: 0.18816
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.418 111.383L106.057 127.887Z",
    fill: "white"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M85.418 111.383L106.057 127.887",
    stroke: "#DB161B",
    strokeWidth: 0.18816
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.418 113.292L105.346 129.157Z",
    fill: "white"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M85.418 113.292L105.346 129.157",
    stroke: "#DB161B",
    strokeWidth: 0.18816
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.418 115.194L105.346 131.059Z",
    fill: "white"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M85.418 115.194L105.346 131.059",
    stroke: "#DB161B",
    strokeWidth: 0.18816
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.418 117.097L104.635 132.33Z",
    fill: "white"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M85.418 117.097L104.635 132.33",
    stroke: "#DB161B",
    strokeWidth: 0.18816
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.7073 118.367L103.925 133.6Z",
    fill: "white"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M84.7073 118.367L103.925 133.6",
    stroke: "#DB161B",
    strokeWidth: 0.18816
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.7073 120.271L102.503 134.233Z",
    fill: "white"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M84.7073 120.271L102.503 134.233",
    stroke: "#DB161B",
    strokeWidth: 0.18816
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.9966 121.541L101.793 135.504Z",
    fill: "white"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M83.9966 121.541L101.793 135.504",
    stroke: "#DB161B",
    strokeWidth: 0.18816
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.2859 122.812L100.364 136.135Z",
    fill: "white"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M83.2859 122.812L100.364 136.135",
    stroke: "#DB161B",
    strokeWidth: 0.18816
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.2859 124.714L99.6533 137.406Z",
    fill: "white"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M83.2859 124.714L99.6533 137.406",
    stroke: "#DB161B",
    strokeWidth: 0.18816
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.2859 126.616L97.5212 138.037Z",
    fill: "white"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M83.2859 126.616L97.5212 138.037",
    stroke: "#DB161B",
    strokeWidth: 0.18816
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.418 102.503V105.676C92.5392 106.731 99.6533 106.731 106.775 105.676V102.503C99.6533 103.558 92.5392 103.558 85.418 102.503Z",
    fill: "white",
    stroke: "#DB161B",
    strokeWidth: 0.150527
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.2859 128.519L96.0927 138.676Z",
    fill: "white"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M83.2859 128.519L96.0927 138.676",
    stroke: "#DB161B",
    strokeWidth: 0.150528
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.2859 130.428L94.6713 139.308Z",
    fill: "white"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M83.2859 130.428L94.6713 139.308",
    stroke: "#DB161B",
    strokeWidth: 0.150528
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.2859 132.33L93.2499 139.947Z",
    fill: "white"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M83.2859 132.33L93.2499 139.947",
    stroke: "#DB161B",
    strokeWidth: 0.150528
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.2859 134.232L90.4 139.947Z",
    fill: "white"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M83.2859 134.232L90.4 139.947",
    stroke: "#DB161B",
    strokeWidth: 0.150528
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.2859 136.135L88.9786 140.578Z",
    fill: "white"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M83.2859 136.135L88.9786 140.578",
    stroke: "#DB161B",
    strokeWidth: 0.150528
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.2859 138.037L86.8393 140.578Z",
    fill: "white"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M83.2859 138.037L86.8393 140.578",
    stroke: "#DB161B",
    strokeWidth: 0.150528
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M86.3888 104.99C86.9249 104.99 87.3594 104.684 87.3594 104.306C87.3594 103.928 86.9249 103.621 86.3888 103.621C85.8528 103.621 85.4182 103.928 85.4182 104.306C85.4182 104.684 85.8528 104.99 86.3888 104.99Z",
    fill: "white",
    stroke: "#DB161B",
    strokeWidth: 0.188159
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M90.2709 105.332C90.807 105.332 91.2415 105.026 91.2415 104.647C91.2415 104.269 90.807 103.963 90.2709 103.963C89.7348 103.963 89.3003 104.269 89.3003 104.647C89.3003 105.026 89.7348 105.332 90.2709 105.332Z",
    fill: "white",
    stroke: "#DB161B",
    strokeWidth: 0.188159
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M94.1542 105.675C94.6903 105.675 95.1248 105.368 95.1248 104.99C95.1248 104.612 94.6903 104.306 94.1542 104.306C93.6182 104.306 93.1836 104.612 93.1836 104.99C93.1836 105.368 93.6182 105.675 94.1542 105.675Z",
    fill: "white",
    stroke: "#DB161B",
    strokeWidth: 0.188162
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M98.0363 105.675C98.5723 105.675 99.0069 105.368 99.0069 104.99C99.0069 104.612 98.5723 104.306 98.0363 104.306C97.5002 104.306 97.0657 104.612 97.0657 104.99C97.0657 105.368 97.5002 105.675 98.0363 105.675Z",
    fill: "white",
    stroke: "#DB161B",
    strokeWidth: 0.188162
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M101.918 105.332C102.454 105.332 102.889 105.026 102.889 104.647C102.889 104.269 102.454 103.963 101.918 103.963C101.382 103.963 100.948 104.269 100.948 104.647C100.948 105.026 101.382 105.332 101.918 105.332Z",
    fill: "white",
    stroke: "#DB161B",
    strokeWidth: 0.188159
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M105.801 104.99C106.337 104.99 106.772 104.684 106.772 104.306C106.772 103.928 106.337 103.621 105.801 103.621C105.265 103.621 104.831 103.928 104.831 104.306C104.831 104.684 105.265 104.99 105.801 104.99Z",
    fill: "white",
    stroke: "#DB161B",
    strokeWidth: 0.188159
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.8115 135.504L80.4358 122.173Z",
    fill: "white"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8115 135.504L80.4358 122.173",
    stroke: "#DB161B",
    strokeWidth: 0.18816
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.3882 134.865L77.5861 122.173Z",
    fill: "white"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3882 134.865L77.5861 122.173",
    stroke: "#DB161B",
    strokeWidth: 0.18816
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.6768 133.601L74.7433 122.173Z",
    fill: "white"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6768 133.601L74.7433 122.173",
    stroke: "#DB161B",
    strokeWidth: 0.18816
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.9646 132.331L71.1826 122.173Z",
    fill: "white"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9646 132.331L71.1826 122.173",
    stroke: "#DB161B",
    strokeWidth: 0.18816
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.541 131.06L68.3326 122.173Z",
    fill: "white"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M50.541 131.06L68.3326 122.173",
    stroke: "#DB161B",
    strokeWidth: 0.18816
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.2532 129.157L63.3507 122.812Z",
    fill: "white"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M51.2532 129.157L63.3507 122.812",
    stroke: "#DB161B",
    strokeWidth: 0.18816
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.541 127.887L59.7943 122.812Z",
    fill: "white"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M50.541 127.887L59.7943 122.812",
    stroke: "#DB161B",
    strokeWidth: 0.18816
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.541 125.985L56.9473 122.812Z",
    fill: "white"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M50.541 125.985L56.9473 122.812",
    stroke: "#DB161B",
    strokeWidth: 0.18816
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.9473 136.135L81.1466 123.443Z",
    fill: "white"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9473 136.135L81.1466 123.443",
    stroke: "#DB161B",
    strokeWidth: 0.18816
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.0823 136.774L81.8573 124.714Z",
    fill: "white"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M59.0823 136.774L81.8573 124.714",
    stroke: "#DB161B",
    strokeWidth: 0.18816
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.2185 137.406L82.5679 125.984Z",
    fill: "white"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2185 137.406L82.5679 125.984",
    stroke: "#DB161B",
    strokeWidth: 0.18816
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.3506 138.037L81.1465 128.519Z",
    fill: "white"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3506 138.037L81.1465 128.519",
    stroke: "#DB161B",
    strokeWidth: 0.18816
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.2007 138.037L81.8574 129.789Z",
    fill: "white"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M66.2007 138.037L81.8574 129.789",
    stroke: "#DB161B",
    strokeWidth: 0.18816
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.3325 138.676L81.8571 131.691Z",
    fill: "white"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M68.3325 138.676L81.8571 131.691",
    stroke: "#DB161B",
    strokeWidth: 0.18816
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.4719 139.309L81.1466 133.602Z",
    fill: "white"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M70.4719 139.309L81.1466 133.602",
    stroke: "#DB161B",
    strokeWidth: 0.18816
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.3147 139.309L81.8573 134.865Z",
    fill: "white"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M73.3147 139.309L81.8573 134.865",
    stroke: "#DB161B",
    strokeWidth: 0.18816
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.1646 139.947L81.8572 136.774Z",
    fill: "white"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M76.1646 139.947L81.8572 136.774",
    stroke: "#DB161B",
    strokeWidth: 0.18816
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.0144 139.948L82.5678 138.038Z",
    fill: "white"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M79.0144 139.948L82.5678 138.038",
    stroke: "#DB161B",
    strokeWidth: 0.18816
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.9966 121.541H80.436C79.2515 127.887 79.2515 134.233 80.436 140.579H83.9966C82.8049 134.233 82.8049 127.887 83.9966 121.541Z",
    fill: "white",
    stroke: "#DB161B",
    strokeWidth: 0.150527
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42 130.428L50.5412 124.082Z",
    fill: "white"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M42 130.428L50.5412 124.082",
    stroke: "#DB161B",
    strokeWidth: 0.150528
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42 125.984L50.5412 133.601Z",
    fill: "white"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M42 125.984L50.5412 133.601",
    stroke: "#DB161B",
    strokeWidth: 0.150528
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.8117 122.812L50.5411 123.443C49.5921 127.463 49.5921 130.844 50.5411 134.865L54.8117 136.135C53.8627 132.115 53.8627 126.832 54.8117 122.812Z",
    fill: "white",
    stroke: "#DB161B",
    strokeWidth: 0.107146
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.746 91.0791V87.8796C103.551 87.9061 101.412 86.0024 101.412 84.0713L90.7517 84.0979C90.7517 86.0024 88.6197 87.9061 85.418 87.9061V91.0791H106.746V91.0791Z",
    fill: "white",
    stroke: "#DB161B",
    strokeWidth: 0.184256
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M100.654 80.29H91.5127V84.0977H100.654V80.29Z",
    fill: "white",
    stroke: "#DB161B",
    strokeWidth: 0.155727
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M99.8917 76.4824H92.2737V80.2901H99.8917V76.4824Z",
    fill: "white",
    stroke: "#DB161B",
    strokeWidth: 0.155727
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M99.8917 72.6748H92.2737V76.4825H99.8917V72.6748Z",
    fill: "white",
    stroke: "#DB161B",
    strokeWidth: 0.155727
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M99.1286 67.5977H93.0344V72.6746H99.1286V67.5977Z",
    fill: "white",
    stroke: "#DB161B",
    strokeWidth: 0.155727
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M99.3956 63.1562H92.7761V67.5986H99.3956V63.1562Z",
    fill: "white",
    stroke: "#DB161B",
    strokeWidth: 0.162295
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M96.4504 65.0595C101.325 65.0595 105.276 62.3603 105.276 59.0307C105.276 55.7011 101.325 53.002 96.4504 53.002C91.5759 53.002 87.6243 55.7011 87.6243 59.0307C87.6243 62.3603 91.5759 65.0595 96.4504 65.0595Z",
    fill: "white",
    stroke: "#DB161B",
    strokeWidth: 0.153016
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.866 58.7133C100.866 60.378 103.07 63.1562 103.07 63.1562C101.469 64.2473 98.8851 65.06 96.4515 65.06C94.0179 65.06 90.9814 64.607 89.8328 63.1562C89.8328 63.1562 92.0366 60.378 92.0366 58.7133C92.0366 57.0493 89.8328 54.9057 89.8328 54.9057C91.4264 53.8146 94.0179 53.002 96.4515 53.002C98.8851 53.002 101.469 53.8146 103.07 54.9057C103.07 54.9057 100.866 57.0493 100.866 58.7133Z",
    fill: "white",
    stroke: "#DB161B",
    strokeWidth: 0.153016
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.3948 58.7133C99.3948 60.378 101.599 63.7908 101.599 63.7908C100.005 64.8819 98.8851 65.06 96.4516 65.06C94.018 65.06 92.453 65.2416 91.3044 63.7908C91.3044 63.7908 93.5083 60.378 93.5083 58.7133C93.5083 57.0493 91.3044 54.2711 91.3044 54.2711C92.8981 53.18 94.018 53.002 96.4516 53.002C98.8851 53.002 100.005 53.18 101.599 54.2711C101.599 54.2711 99.3948 57.0493 99.3948 58.7133Z",
    fill: "white",
    stroke: "#DB161B",
    strokeWidth: 0.153016
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M87.6243 61.252C88.8429 61.252 89.8308 60.3997 89.8308 59.3482C89.8308 58.2967 88.8429 57.4443 87.6243 57.4443C86.4056 57.4443 85.4177 58.2967 85.4177 59.3482C85.4177 60.3997 86.4056 61.252 87.6243 61.252Z",
    fill: "white",
    stroke: "#DB161B",
    strokeWidth: 0.153016
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M105.276 61.252C106.495 61.252 107.483 60.3997 107.483 59.3482C107.483 58.2967 106.495 57.4443 105.276 57.4443C104.058 57.4443 103.07 58.2967 103.07 59.3482C103.07 60.3997 104.058 61.252 105.276 61.252Z",
    fill: "white",
    stroke: "#DB161B",
    strokeWidth: 0.153016
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M96.4504 61.252C97.6691 61.252 98.657 60.3997 98.657 59.3482C98.657 58.2967 97.6691 57.4443 96.4504 57.4443C95.2318 57.4443 94.2439 58.2967 94.2439 59.3482C94.2439 60.3997 95.2318 61.252 96.4504 61.252Z",
    fill: "white",
    stroke: "#DB161B",
    strokeWidth: 0.153016
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M96.4504 54.9063C97.6691 54.9063 98.657 54.054 98.657 53.0025C98.657 51.951 97.6691 51.0986 96.4504 51.0986C95.2318 51.0986 94.2439 51.951 94.2439 53.0025C94.2439 54.054 95.2318 54.9063 96.4504 54.9063Z",
    fill: "white",
    stroke: "#DB161B",
    strokeWidth: 0.153016
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M89.9885 91.0792C91.2506 91.0792 92.2738 90.2268 92.2738 89.1753C92.2738 88.1239 91.2506 87.2715 89.9885 87.2715C88.7263 87.2715 87.7031 88.1239 87.7031 89.1753C87.7031 90.2268 88.7263 91.0792 89.9885 91.0792Z",
    fill: "white",
    stroke: "#DB161B",
    strokeWidth: 0.155725
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M102.177 91.0792C103.439 91.0792 104.462 90.2268 104.462 89.1753C104.462 88.1239 103.439 87.2715 102.177 87.2715C100.915 87.2715 99.8914 88.1239 99.8914 89.1753C99.8914 90.2268 100.915 91.0792 102.177 91.0792Z",
    fill: "white",
    stroke: "#DB161B",
    strokeWidth: 0.155725
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.7517 84.0977H101.412L96.0855 89.8097L90.7517 84.0977Z",
    fill: "white",
    stroke: "#DB161B",
    strokeWidth: 0.155725
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M96.0825 91.0799C97.7654 91.0799 99.1296 89.9434 99.1296 88.5414C99.1296 87.1394 97.7654 86.0029 96.0825 86.0029C94.3996 86.0029 93.0354 87.1394 93.0354 88.5414C93.0354 89.9434 94.3996 91.0799 96.0825 91.0799Z",
    fill: "white",
    stroke: "#DB161B",
    strokeWidth: 0.207633
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M99.8308 107.585H85.2369C84.7462 107.585 84.3484 107.886 84.3484 108.258V110.719C84.3484 111.091 84.7462 111.393 85.2369 111.393H99.8308C100.322 111.393 100.719 111.091 100.719 110.719V108.258C100.719 107.886 100.322 107.585 99.8308 107.585Z",
    fill: "white",
    stroke: "#DB161B",
    strokeWidth: 0.188159
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.705 104.412C103.731 104.412 102.144 105.891 102.144 107.729V110.614C102.144 112.452 103.731 113.931 105.705 113.931C107.679 113.931 109.266 112.452 109.266 110.614V107.729C109.266 105.891 107.679 104.412 105.705 104.412ZM105.705 105.683C104.52 105.683 103.566 106.867 103.566 108.339V110.011C103.566 111.483 104.52 112.66 105.705 112.66C106.889 112.66 107.837 111.483 107.837 110.011V108.339C107.837 106.867 106.889 105.683 105.705 105.683Z",
    fill: "white",
    stroke: "#DB161B",
    strokeWidth: 0.18816
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.1983 105.051C86.0138 105.051 85.0663 106.228 85.0663 107.7V110.643C85.0663 112.115 86.0138 113.299 87.1983 113.299C88.3828 113.299 89.3304 112.115 89.3304 110.643V107.7C89.3304 106.228 88.3828 105.051 87.1983 105.051ZM87.1983 103.78C85.2242 103.78 83.6377 105.259 83.6377 107.097V111.253C83.6377 113.091 85.2242 114.57 87.1983 114.57C89.1725 114.57 90.7589 113.091 90.7589 111.253V107.097C90.7589 105.259 89.1725 103.78 87.1983 103.78Z",
    fill: "white",
    stroke: "#DB161B",
    strokeWidth: 0.18816
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.5057 106.314C80.3212 106.314 79.3664 107.499 79.3664 108.97V109.659C79.3664 111.131 80.3212 112.316 81.5057 112.316C82.6902 112.316 83.6378 111.131 83.6378 109.659V108.97C83.6378 107.499 82.6902 106.314 81.5057 106.314ZM81.5057 105.051C79.5316 105.051 77.9451 106.53 77.9451 108.367V110.27C77.9451 112.107 79.5316 113.586 81.5057 113.586C83.4726 113.586 85.0663 112.107 85.0663 110.27V108.367C85.0663 106.53 83.4726 105.051 81.5057 105.051Z",
    fill: "white",
    stroke: "#DB161B",
    strokeWidth: 0.18816
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.963 104.563C70.8309 104.563 69.1224 105.884 69.1224 107.528V110.816C69.1224 112.46 70.8309 113.78 72.963 113.78C75.095 113.78 76.8035 112.46 76.8035 110.816V107.528C76.8035 105.884 75.095 104.563 72.963 104.563ZM72.963 103.142C69.4167 103.142 66.5596 104.8 66.5596 106.853V111.498C66.5596 113.551 69.4167 115.202 72.963 115.202C76.5092 115.202 79.3663 113.551 79.3663 111.498V106.853C79.3663 104.8 76.5092 103.142 72.963 103.142Z",
    fill: "white",
    stroke: "#DB161B",
    strokeWidth: 0.18816
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.229 105.194C117.097 105.194 115.382 106.523 115.382 108.166V111.454C115.382 113.098 117.097 114.419 119.229 114.419C121.354 114.419 123.07 113.098 123.07 111.454V108.166C123.07 106.523 121.354 105.194 119.229 105.194ZM119.229 103.78C115.676 103.78 112.819 105.431 112.819 107.484V112.129C112.819 114.182 115.676 115.833 119.229 115.833C122.776 115.833 125.633 114.182 125.633 112.129V107.484C125.633 105.431 122.776 103.78 119.229 103.78Z",
    fill: "white",
    stroke: "#DB161B",
    strokeWidth: 0.18816
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M115.204 107.585H107.59C107.334 107.585 107.126 107.886 107.126 108.258V110.719C107.126 111.091 107.334 111.393 107.59 111.393H115.204C115.46 111.393 115.667 111.091 115.667 110.719V108.258C115.667 107.886 115.46 107.585 115.204 107.585Z",
    fill: "white",
    stroke: "#DB161B",
    strokeWidth: 0.188159
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M104.014 106.953H99.5719C99.4226 106.953 99.3015 107.355 99.3015 107.851V111.132C99.3015 111.628 99.4226 112.03 99.5719 112.03H104.014C104.163 112.03 104.284 111.628 104.284 111.132V107.851C104.284 107.355 104.163 106.953 104.014 106.953Z",
    fill: "white",
    stroke: "#DB161B",
    strokeWidth: 0.188159
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M80.525 106.953H76.0834C75.9341 106.953 75.813 107.355 75.813 107.851V111.132C75.813 111.628 75.9341 112.03 76.0834 112.03H80.525C80.6743 112.03 80.7954 111.628 80.7954 111.132V107.851C80.7954 107.355 80.6743 106.953 80.525 106.953Z",
    fill: "white",
    stroke: "#DB161B",
    strokeWidth: 0.188159
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5728 106.314H60.6898C60.3911 106.314 60.1489 106.817 60.1489 107.437V111.538C60.1489 112.158 60.3911 112.661 60.6898 112.661H69.5728C69.8715 112.661 70.1136 112.158 70.1136 111.538V107.437C70.1136 106.817 69.8715 106.314 69.5728 106.314Z",
    fill: "white",
    stroke: "#DB161B",
    strokeWidth: 0.188159
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M130.823 106.953H122.574C122.297 106.953 122.072 107.456 122.072 108.076V112.177C122.072 112.797 122.297 113.299 122.574 113.299H130.823C131.101 113.299 131.326 112.797 131.326 112.177V108.076C131.326 107.456 131.101 106.953 130.823 106.953Z",
    fill: "white",
    stroke: "#DB161B",
    strokeWidth: 0.188159
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOm);
export default __webpack_public_path__ + "static/media/OM.80693551551a464608845e0c6bb57509.svg";
export { ForwardRef as ReactComponent };